import { useMemo } from 'react';
import { useOrientation } from 'react-use';

const useIsLandscape = () => {
  const defaultState = useMemo(() => {
    const { orientation: screenOrientation } = window.screen;
    const options = {
      angle: 0,
      type: 'landscape-primary',
    };

    if (screenOrientation) {
      const { angle, type } = screenOrientation;

      options.angle = angle;
      options.type = type;
    } else if (window.orientation) {
      options.angle =
        typeof window.orientation === 'number' ? window.orientation : 0;
    }

    return options;
  }, []);

  const { type: orientation } = useOrientation(defaultState);
  const isPortrait = orientation.includes('portrait-');

  return !isPortrait;
};

export default useIsLandscape;
